import { ChargePoint } from '../../common/redux/api/web-api'

function getInstallationPhaseMode(chargePoint: ChargePoint | undefined): string | undefined {
    return chargePoint?.connectors?.at(0)?.installationPhaseMode
}

export default getInstallationPhaseMode
